const CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function generatePassword(n = 10) {
    return Array.from({ length: n }, () =>
        CHARSET[Math.floor(Math.random() * CHARSET.length)],
    ).join('');
}
